import React from 'react';
import { motion } from 'framer-motion';

export const Devices: React.FC = () => {
    const devices = [
        {
            image: '/precise.png',
            name: 'Precise',
            desc: 'A telescopic, motorised nail capable of very exact lengthening and deformity correction. Controlled remotely, it doesn’t require permanent external hardware.',
        },
        {
            image: '',
            name: 'Lengthening Over Nail (LON)',
            desc: 'Lengthening over Nail is a hybrid technique that combines an internal, partial weight-bearing intramedullary nail which stabilizes new bone, with a temporary external fixator which controls distraction.',
        },
        {
            image: '/fitbone.png',
            name: 'Fitbone',
            desc: 'A fully internal, motorised intramedullary lengthening nail with an implanted electric drive powered by an external transmitter, Fitbone provides smooth, gradual distraction process.',
        },
    ];

    return (
        <section className="py-32 bg-white">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
                    <div>
                        <span className="text-[#11BC97] font-bold tracking-widest uppercase text-sm mb-4 block">Technology</span>
                        <h2 className="text-4xl font-bold text-black">Lengthening Devices</h2>
                    </div>
                    <p className="text-gray-500 max-w-md text-right md:text-left">We only use the highest quality FDA approved medical devices.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {devices.map((device, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: idx * 0.1 }}
                            className="bg-white p-10 rounded-[2.5rem] border border-gray-100 hover:border-[#11BC97]/30 hover:shadow-2xl hover:shadow-[#11BC97]/5 transition-all duration-300 group flex flex-col justify-between h-full min-h-[300px]"
                        >
                            <div>
                                <div className="flex items-center justify-center mb-8">
                                    {device.image ? (
                                        <div className="w-40 h-40 bg-[#F8FDFB] rounded-2xl flex items-center justify-center overflow-hidden">
                                            <img src={device.image} alt={device.name} className="w-full h-full object-contain" />
                                        </div>
                                    ) : <div className="w-40 h-40" />}
                                </div>
                                <h3 className="text-2xl font-bold mb-4">{device.name}</h3>
                                <p className="text-gray-500 leading-relaxed mb-2">{device.desc}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};